import { useIntl } from "react-intl";
import {
  type FormattedIsoDateProps,
  formatDate,
} from "../../../components/FormattedIsoDate/FormattedIsoDate";
import { dateFromIsoDateTime } from "../../../utils/dateTime";
import messages from "../SegmentHeader/SegmentHeader.messages";

type Props = {
  // ISO formatted date time string.
  departureDate?: string;
  className?: string;
  dateOptions?: Omit<FormattedIsoDateProps, "date">;
};

const defaultDateOptions: Omit<FormattedIsoDateProps, "date"> = {
  month: "short",
  day: "numeric",
  year: "numeric",
};

export function FormattedDepartureDate({
  departureDate,
  className,
  dateOptions = defaultDateOptions,
}: Props) {
  const intl = useIntl();

  if (departureDate) {
    let date: string | undefined = undefined;
    date = formatDate(dateFromIsoDateTime(departureDate), intl, dateOptions);

    return <time className={className}>{date}</time>;
  } else {
    return (
      <span className={className}>
        {intl.formatMessage(messages.departingNow)}
      </span>
    );
  }
}
